import { render, staticRenderFns } from "./GuppyChatEmptyView.vue?vue&type=template&id=5932635c&scoped=true&"
import script from "./GuppyChatEmptyView.vue?vue&type=script&lang=js&"
export * from "./GuppyChatEmptyView.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatEmptyView.vue?vue&type=style&index=0&id=5932635c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932635c",
  null
  
)

export default component.exports